import utils from './utils'

export default function (instance) {
  instance.$contentful.getEntries({
    content_type: 'episode',
    locale: 'en-US',
    order: '-fields.season,-fields.order',
    include: 1
  }).then((episodeEntries) => {
    const episodes = episodeEntries.items.map((entry) => {
      const authors = entry.fields.authors.map((author) => ({ name: author.fields.name, picture: author.fields.picture.fields.file }))
      const { authors: rawAuthors, ...episode } = entry.fields
      episode.authors = authors
      if (entry.fields.filters) {
        const filters = entry.fields.filters.map((data) => (data.fields ? data.fields.title : null))
        const cleanFilters = filters.filter(Boolean)
        episode.filters = cleanFilters
      }
      const videoId = utils.getVideoIdFromYoutubeUrl(episode.videoUrl)
      const url = videoId ? `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg` : ''
      episode.bgURL = url
      return episode
    })

    instance.$store.commit('setVideoList', episodes)
  }).catch((err) => {
    alert(`Ìt wasn't possible to load the episodes.\n\n${err}`)
  })

  instance.$contentful.getEntries({
    content_type: 'filter',
    locale: 'en-US',
    include: 1
  }).then((filterEntries) => {
    const tags = filterEntries.items.map((entry) => {
      return entry.fields.title
    })
    instance.$store.commit('setFilterList', tags)
  }).catch((err) => {
    alert(`Ìt wasn't possible to load the tags.\n\n${err}`)
  })
}
